// Search bar related
const ORIGIN_LONGNAME_CHANGE = 'ORIGIN_LONGNAME_CHANGE'
const ORIGIN_SHORTNAME_CHANGE = 'ORIGIN_SHORTNAME_CHANGE'
const ORIGIN_GOOGLE_PLACE_ID_CHANGE = 'ORIGIN_GOOGLE_PLACE_ID_CHANGE'
const ORIGIN_KIND_CHANGE = 'ORIGIN_KIND_CHANGE'
const ORIGIN_CHANGE = 'ORIGIN_CHANGE'
const ORIGIN_LATLNG_CHANGE = 'ORIGIN_LATLNG_CHANGE'
const DESTINATION_LONGNAME_CHANGE = 'DESTINATION_LONGNAME_CHANGE'
const DESTINATION_SHORTNAME_CHANGE = 'DESTINATION_SHORTNAME_CHANGE'
const DESTINATION_GOOGLE_PLACE_ID_CHANGE = 'DESTINATION_GOOGLE_PLACE_ID_CHANGE'
const DESTINATION_CHANGE = 'DESTINATION_CHANGE'
const DESTINATION_KIND_CHANGE = 'DESTINATION_KIND_CHANGE'
const DESTINATION_LATLNG_CHANGE = 'DESTINATION_LATLNG_CHANGE'
const SET_HANDOVER_MODE = 'SET_HANDOVER_MODE'

const PASSENGER_OPTIONS_DATA_RECEIVED = 'PASSENGER_OPTIONS_DATA_RECEIVED'
const PASSENGER_MINUS = 'PASSENGER_MINUS'
const PASSENGER_ADD = 'PASSENGER_ADD'
const PASSENGER_REMOVE = 'PASSENGER_REMOVE'
const PASSENGER_UPDATE = 'PASSENGER_UPDATE'
const PAX_UPDATE = 'PAX_UPDATE'

const SEARCH_PARAMS_UPDATE = 'SEARCH_PARAMS_UPDATE'

// Selection related
const OUTBOUND_FARE_CLASS_SELECTED = 'OUTBOUND_FARE_CLASS_SELECTED'
const INBOUND_FARE_CLASS_SELECTED = 'INBOUND_FARE_CLASS_SELECTED'
const MODE_SELECTED = 'MODE_SELECTED'
const MODE_INITIALIZED = 'MODE_INITIALIZED'
const TICKET_OUTBOUND_SELECTED = 'TICKET_OUTBOUND_SELECTED'
const TICKET_INBOUND_SELECTED = 'TICKET_INBOUND_SELECTED'
const TICKET_OUTBOUND_REMOVED = 'TICKET_OUTBOUND_REMOVED'
const TICKET_INBOUND_REMOVED = 'TICKET_INBOUND_REMOVED'
const TICKET_CLEAR_RESULTS = 'TICKET_CLEAR_RESULTS'
const BOOK_NOW_INITIATED = 'BOOK_NOW_INITIATED'
const MODE_CHANGED = 'MODE_CHANGED'

// Response related
const CONFIG_RECEIVED = 'CONFIG_RECEIVED'
const CONFIG_FAILED = 'CONFIG_FAILED'

const RESPONSES_LOADING = 'RESPONSES_LOADING'
const RESPONSE_ADD = 'RESPONSE_ADD'
const RESPONSE_REPLACE = 'RESPONSE_REPLACE'
const RESPONSE_REPLACE_ALL = 'RESPONSE_REPLACE_ALL'
const RESPONSE_SEARCH_FAILED = 'RESPONSE_SEARCH_FAILED'
const DETAILS_UPDATE = 'DETAILS_UPDATE'
const DETAILS_UPDATE_FAILED = 'DETAILS_UPDATE_FAILED'
const DETAILS_REAPPLY = 'DETAILS_REAPPLY'

const MODE_LOADING = 'MODE_LOADING'
const MODE_LOADED = 'MODE_LOADED'
const MODE_POLLING = 'MODE_POLLING'

const UPDATE_TRANSFER = 'UPDATE_TRANSFER'
const OUTBOUND_DEPARTURE_TIME_INITIALIZED = 'OUTBOUND_DEPARTURE_TIME_INITIALIZED'
const INBOUND_DEPARTURE_TIME_INITIALIZED = 'INBOUND_DEPARTURE_TIME_INITIALIZED'
const TIME_CHANGE = 'TIME_CHANGE'
const FERRY_TYPE_CHANGE = 'FERRY_TYPE_CHANGE'
const PAGE_INCREASE = 'PAGE_INCREASE'
const UPDATE_LAST_URL = 'UPDATE_LAST_URL'

const API_MESSAGES_SET = 'API_MESSAGES_SET'

const NO_RESULTS_FOR_TIME = 'NO_RESULTS_FOR_TIME'
const NO_RESULTS_FOR_FERRY_TYPE = 'NO_RESULTS_FOR_FERRY_TYPE'
const NO_MORE_RESULTS = 'NO_MORE_RESULTS'

// Logging related
const LOG_PERFORM_SEARCH = 'LOG_PERFORM_SEARCH'

// Currency related
const CURRENCY_CHANGED = 'CURRENCY_CHANGED'
const CURRENCY_DATA_RECEIVED = 'CURRENCY_DATA_RECEIVED'

// l10n related
const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED'

export default {
  ORIGIN_LONGNAME_CHANGE,
  ORIGIN_SHORTNAME_CHANGE,
  ORIGIN_GOOGLE_PLACE_ID_CHANGE,
  ORIGIN_CHANGE,
  ORIGIN_KIND_CHANGE,
  ORIGIN_LATLNG_CHANGE,
  DESTINATION_LONGNAME_CHANGE,
  DESTINATION_SHORTNAME_CHANGE,
  DESTINATION_GOOGLE_PLACE_ID_CHANGE,
  DESTINATION_CHANGE,
  DESTINATION_KIND_CHANGE,
  DESTINATION_LATLNG_CHANGE,
  SET_HANDOVER_MODE,

  PASSENGER_OPTIONS_DATA_RECEIVED,
  PASSENGER_MINUS,
  PASSENGER_ADD,
  PASSENGER_REMOVE,
  PASSENGER_UPDATE,
  PAX_UPDATE,

  SEARCH_PARAMS_UPDATE,

  OUTBOUND_FARE_CLASS_SELECTED,
  INBOUND_FARE_CLASS_SELECTED,
  MODE_SELECTED,
  MODE_INITIALIZED,
  TICKET_OUTBOUND_SELECTED,
  TICKET_INBOUND_SELECTED,
  TICKET_OUTBOUND_REMOVED,
  TICKET_INBOUND_REMOVED,
  TICKET_CLEAR_RESULTS,
  BOOK_NOW_INITIATED,
  MODE_CHANGED,

  CONFIG_RECEIVED,
  CONFIG_FAILED,

  RESPONSES_LOADING,
  RESPONSE_ADD,
  RESPONSE_REPLACE,
  RESPONSE_REPLACE_ALL,
  RESPONSE_SEARCH_FAILED,
  DETAILS_UPDATE,
  DETAILS_UPDATE_FAILED,
  DETAILS_REAPPLY,

  MODE_LOADING,
  MODE_LOADED,
  MODE_POLLING,

  UPDATE_TRANSFER,
  OUTBOUND_DEPARTURE_TIME_INITIALIZED,
  INBOUND_DEPARTURE_TIME_INITIALIZED,
  TIME_CHANGE,
  FERRY_TYPE_CHANGE,
  PAGE_INCREASE,
  UPDATE_LAST_URL,

  API_MESSAGES_SET,

  NO_RESULTS_FOR_TIME,
  NO_RESULTS_FOR_FERRY_TYPE,
  NO_MORE_RESULTS,

  LOG_PERFORM_SEARCH,

  CURRENCY_CHANGED,
  CURRENCY_DATA_RECEIVED,

  LANGUAGE_CHANGED,
}
